import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface ChatBubbleRowProps {
  /** Whether this is an inbound (left) or outbound (right) message */
  readonly align: "start" | "end";
  /** Extra className */
  readonly className?: string;
  readonly children: ReactNode;
}

/**
 * A row that constrains and aligns a chat bubble (max-width 75%).
 */
export function ChatBubbleRow({ align, className, children }: ChatBubbleRowProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex max-w-[75%]",
        align === "start" ? "self-start" : "self-end justify-end",
        className,
      )}
    >
      {children}
    </div>
  );
}
